import React from "react";
import { Box, Typography } from "@mui/material";
import check from "../../../../assets/images/check.svg";
import ButtonComp from "../../../../components/Button";

export default function SubmissionSuccess({
  heading,
  para,
  onHomeClick,
}: any) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      px={2}
      bgcolor="#ffffff"
      height="100vh"
    >
      <Box>
        <img
          src={check}
          alt="success"
          style={{ height: 200, width: 200, objectFit: "contain" }}
        />
      </Box>

      <Typography fontSize={38} fontWeight={600} gutterBottom>
        {heading}
      </Typography>

      <Typography fontSize={30} fontWeight={500} maxWidth={900} mb={4}>
        {para}
      </Typography>

      <ButtonComp height={40} width={200} variant="contained" onClick={onHomeClick}>
        Home
      </ButtonComp>
    </Box>
  );
}
